import { createPortal } from 'react-dom';
import { useToast } from '@/hooks/useToast';
import styles from './Toast.module.css';

/** Se monta una sola vez en el árbol (ver App.tsx) y escucha el ToastContext global. */
export function ToastViewport() {
  const { toast } = useToast();
  const toastRoot = document.getElementById('modal-root');
  if (!toastRoot) return null;

  return createPortal(
    <div className={[styles.toast, toast && styles.visible].filter(Boolean).join(' ')} role="status">
      {toast?.message ?? ''}
    </div>,
    toastRoot,
  );
}
